@if (showTimeInfoOnTop) {
    <div class="badges-wrapper timer-top">
        <ms-event-info [event]="event" [showEventTimerInfoSection]="showEventTimerInfoSection" [showFixedFooterSection]="false" />
    </div>
}
<ms-event-name
    [event]="event"
    [showParticipantImage]="showParticipantImage"
    [showParticipantStats]="showParticipantStats"
    [showLogoColor]="showLogoColor" />
@if (!isAllMarketsLinkEnabled) {
    <div class="badges-wrapper" [style.flexDirection]="showEventTimerInfoSection ? 'row' : 'column'">
        @if (gameNotes) {
            <ms-game-notes [gameNotes]="gameNotes" />
        }
        <ms-event-info
            [event]="event"
            [showEventTimerInfoSection]="showEventTimerInfoSection && !showTimeInfoOnTop"
            [mediaEnabled]="mediaEnabled"
            [disableBadges]="disableBadges"
            [showPlayerStatisticsButton]="showPlayerStatisticsButton">
            @if (promotedFixtureIdsMap[event.id]) {
                <ms-promotion-badge />
            }
        </ms-event-info>
    </div>
}
